
<template>
  <Breadcrumbs main="Event" title="Upload Video" />
  <div class="container-fluid">
    <div
      v-if="
        this.is_event_permission === 'Y' && this.eventDetails.uploadable === 'Y'
      "
    >
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div
                class="col-xl-12"
                style="
                  text-align: left;
                  background-color: lightgray;
                  border-radius: 1rem;
                "
              >
                <b>&nbsp;</b><br />
                <b>{{ t("usageGuidelines") }}</b>
                <p class="small-text">
                  1.{{ t("guide1Prefix") }} <span style="color: red; text-decoration: underline">{{ t("guide1Highlight") }}</span>
                  {{ t("guide1Tail") }}<br />
                  2.{{ t("guide2") }}<br />
                  3.{{ t("guide3Prefix") }} <span style="color: red;">{{ currentLanguage === "en" ? `${this.min_duration_sec} ${t("guide3Mid")} ${this.max_duration_sec} ${t("guide3Suffix")}` : `ต้องเป็น มีความยาวอยู่ในช่วงระหว่าง ${this.min_duration_sec} ถึง ${this.max_duration_sec} วินาที เท่านั้น` }}</span><br />
                  4.{{ t("guide4") }}<br />
                  5.{{ t("guide5") }} <br />
                </p>

                <div class="row">
                  <div class="col-xl-9 col-sm-9">
                    <textarea
                      class="small-text"
                      rows="13"
                      v-model="this.eventDetails.post_caption"
                    ></textarea>
                  </div>
                  <div
                    class="col-xl-3 col-sm-3 qr-code-container"
                    style="text-align: center"
                  >
                    <vue-qrcode
                      :value="this.qr_code"
                      :options="{
                        errorCorrectionLevel: 'high',
                        width: 180,
                        quality: 0.99,
                      }"
                    ></vue-qrcode>
                    <br />
                    <a
                      style="font-size: smaller"
                      target="_blank"
                      :href="
                        this.website_url +'/'+ this.$route.params.q + '/qr'
                      "
                      ><u>{{ t("downloadQrCode") }}</u></a
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-4 col-sm-4" style="text-align: center">
                <p style="color: rgb(0, 0, 0)">
                  {{ t("uploadTotal") }}: {{ this.total }} (<a
                    target="_blank"
                    :href="'/upload-videos/' + this.eventDetails.event_key"
                    ><u>{{ t("fileList") }}</u></a
                  >)
                </p>
              </div>
              <div class="col-xl-4 col-sm-4" style="text-align: center">
                <p style="color: rgb(255, 102, 0)">
                  {{ t("waitForTagging") }}: {{ this.processing }}
                </p>
              </div>
              <div class="col-xl-4 col-sm-4" style="text-align: center">
                <p style="color: green">{{ t("tagged") }}: {{ this.taged }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card card-btn-upload">
        <div class="row" v-if="this.eventDetails.is_event_stage === 'Y'" style="padding-top: 10px;">
          <div class="col-sm-1 col-lg-1 col-xl-1"></div>
          <div class="col-sm-10 col-lg-10 col-xl-10">
            <div class="form-floating mb-3">
              <select 
                class="form-select"
                required
                id="floatingSelect"
                v-model="event_stages"
                aria-label="Floating label select example"
              >
                <option
                  v-for="(item, index) in this.eventDetails.stage"
                  :key="index"
                  :value="item.id"
                >
                  #{{ this.currentLanguage === "en" ? item.name_en : item.name }}
                </option>
              </select>
              <label for="floatingSelect"
                ># / Photo Locations / Activity / Stations</label
              >
            </div>
          </div>
          <div class="col-sm-1 col-lg-1 col-xl-1"></div>
        </div>

        <div class="col-sm-12">
          <div
            class="d-flex flex-column justify-content-center align-items-center text-center"
            style="white-space: normal; word-break: break-word"
          >
            <div style="font-size: 14px; color: gray">
              upload videos to event
            </div>
            <b
              style="
                white-space: normal;
                word-break: break-word;
                margin-top: 4px;
              "
            >
              {{ this.eventDetails.title }} ({{ this.user.display_name }})
            </b>
          </div>
          <div class="card-body btn-showcase">
            <label
              class="btn btn-primary btn-sm"
              :class="{ disabled: upload_store_vdo.isUploading }"
              for="selectBtn"
            >
              <vue-feather type="upload-cloud" size="13"></vue-feather> Choose
              file to upload
            </label>
            <button
              class="btn btn-success btn-sm"
              :class="{ disabled: upload_store_vdo.isUploading }"
              @click.prevent="
                upload_store_vdo.uploadSelectedFiles(
                  this.eventDetails.event_key,
                  this.eventDetails.event_watermark_hori,
                  this.eventDetails.event_watermark_vertical,
                  this.user.user_id,
                  this.eventDetails.event_id,
                  this.eventDetails.server_upload_url_text,
                  this.eventDetails.server_upload_url_aws,
                  this.eventDetails.is_free_download,
                  this.eventDetails.is_add_watermark_for_free_download,
                  this.eventDetails.is_event_stage,
                  this.event_stages,
                  this.eventDetails.is_mhao,
                  this.eventDetails.is_hybrid,
                  this.eventDetails.is_mhao_hybrid,
                  this.credit_balance,
                  this.is_image_addjustment,
                  this.eventDetails.capture_tag_sec
                )
              "
              type="button"
              data-bs-toggle="tooltip"
              title="Upload"
            >
              {{
                upload_store_vdo.failed_count > 0 ? "Retry upload" : "Start upload"
              }}
            </button>
            <button
              class="btn btn-info btn-sm"
              :class="{ disabled: upload_store_vdo.isUploading }"
              type="button"
              data-bs-toggle="tooltip"
              title="Clear"
              @click.prevent="clear_upload"
            >
              <vue-feather type="refresh-cw" size="15"></vue-feather> Reset
            </button>
            <div class="row">
              <div class="col-xl-4 col-sm-4">
                <b
                  >upload queue (<span style="color: cornflowerblue">{{
                    upload_store_vdo.selectedFiles.length -
                    upload_store_vdo.success_count
                  }}</span
                  >)
                </b>
              </div>
              <div class="col-xl-4 col-sm-4">
                <b
                  >upload successful (<a
                    target="_blank"
                    :href="'/upload-videos/' + this.eventDetails.event_key"
                    ><span style="color: green">{{
                      upload_store_vdo.success_count
                    }}</span></a
                  >)
                </b>
              </div>
              <div class="col-xl-4 col-sm-4">
                <b
                  >upload failed (<span style="color: red">{{
                    upload_store_vdo.failed_count
                  }}</span
                  >)
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span
        v-show="uploadingFilesFailed.length"
        style="color: red; font-size: small"
      >
        {{ upload_store_vdo.errorMsg }}</span
      >
      <div style="height: 450px;">
      <div
        class="row"
        v-show="uploadingFilesFailed.length && !upload_store_vdo.isUploading"
      >
        <div class="col-sm-12">
          <div class="card">
            <div class="my-gallery card-body row gallery-with-description">
              <div
                class="col-xl-4 col-sm-4"
                v-for="(file, index) in uploadingFilesFailed"
                :key="index"
              >
                <span class="failed"
                  >{{ file.file.name }} [failed]
                  <div class="progress-bar-wrapper"></div>
                </span>
              </div>
            </div>
            &nbsp;
          </div>
        </div>
      </div>
      <div class="row" v-show="uploadingFiles.length">
        <div class="col-sm-12">
          <div class="card">
            <div class="my-gallery card-body row gallery-with-description">
              <div
                class="col-xl-12 col-sm-12"
                v-for="(file, index) in uploadingFiles"
                :key="index"
              >
                <span class="uploading"
                  >{{ file.file.name }} [uploading {{ file.percentage }}%]
                  <div class="progress-bar-wrapper">
                    <div
                      class="progress-bar-fill"
                      :style="{ width: file.percentage + '%' }"
                    ></div>
                  </div>
                </span>
              </div>
            </div>
            &nbsp;
          </div>
        </div>
      </div>
      </div>
    </div>
    <div v-if="this.eventDetails.uploadable === 'N'">
      <div class="row">
              <div
                class="col-xl-12"
                style="
                  text-align: left;
                  background-color: lightgray;
                  border-radius: 1rem;
                "
              >
                <b>&nbsp;</b><br />
                <b>Video Upload System Usage Guidelines</b>
                <p class="small-text">
                  1.{{ t("guide1Prefix") }} <span style="color: red; text-decoration: underline">{{ t("guide1HighlightLocked") }}</span>
                  {{ t("guide1TailLocked") }}<br />
                  2.{{ t("guide2Locked") }}<br />
                  3.{{ t("guide3LockedPrefix") }}  <span style="color: red;"> {{ this.min_duration_sec }}  {{ t("guide3Mid") }}   {{ this.max_duration_sec }} {{ t("guide3LockedSuffix") }}</span> <br />
                  4.{{ t("guide4Locked") }}<br />
                  5.{{ t("guide5Locked") }} <br />
                </p>

                <div class="row">
                  <div class="col-xl-9 col-sm-9">
                    <textarea
                      class="small-text"
                      rows="13"
                      v-model="this.eventDetails.post_caption"
                    >
                    </textarea>
                  </div>
                  <div
                    class="col-xl-3 col-sm-3 qr-code-container"
                    style="text-align: center"
                  >
                    <vue-qrcode
                      :value="this.qr_code"
                      :options="{
                        errorCorrectionLevel: 'high',
                        width: 180,
                        quality: 0.99,
                      }"
                    ></vue-qrcode
                    ><br />
                    <a
                      style="font-size: smaller"
                      target="_blank"
                      :href="
                        this.website_url + '/' + this.$route.params.q + '/qr'
                      "
                      ><u>{{ t("downloadQrCodeLarge") }}</u></a
                    >
                  </div>
                </div>
              </div>
            </div>
            
      
    
      {{ t("uploadTotal") }}: {{ this.total }} (<a
        target="_blank"
        :href="'/upload-videos/' + this.eventDetails.event_key"
        ><u>{{ t("fileList") }}</u></a
      >)

      <hr>
      <div class="d-flex justify-content-center" style="color: red">
        &nbsp;&nbsp;&nbsp;{{ t("uploadClosedMessage") }}
      </div>
    </div>
    <div v-if="this.is_event_permission === 'CHECKING'">
      <div class="d-flex justify-content-center">{{ t("authorizedChecking") }}</div>
    </div>
    <div v-if="this.is_event_permission === 'N'">
      <div class="d-flex justify-content-center">
        {{ t("pageNotAuthorized") }}
      </div>

      <div v-if="this.is_mhao !== 'Y' && this.loadding === 'N'">
        <div class="d-flex justify-content-center">{{ t("eventNotCorrect") }}</div>
      </div>
    </div>
  </div>

  <input
    id="selectBtn"
    type="file"
    multiple
    accept=".mp4"
    title="Upload file"
    @change="upload_store_vdo.onSelectFiles"
  />
</template>
  <script>
import { useUploadStoreVdo } from "./upload_vdo";
import axios from "axios";
import language from "@/components/header/language.vue";

const LANGUAGE_TEXT = {
  en: {
    usageGuidelines: "Video Upload System Usage Guidelines",
    guide1Prefix: "To increase upload speed, open multiple tabs",
    guide1Highlight: "using different browsers or modes",
    guide1Tail: "such as Google Chrome, Chrome Incognito, Microsoft Edge, and Edge InPrivate (Upload up to 2400 files per browser)",
    guide2: "While uploading files to the system, you can minimize the window to do other tasks while the system continues uploading at normal speed",
    guide3Prefix: "Upload .MP4 files only and duration between",
    guide3Mid: "and",
    guide3Suffix: "seconds",
    guide4: "Videos should not exceed 15 seconds in length (Set camera to Slow at 30FPS, shoot for approximately 3-4 seconds)",
    guide5: "Make sure file names are unique. The system will skip files with duplicate names",
    guide1HighlightLocked: "using different browsers or modes",
    guide1TailLocked: "such as Google Chrome, Chrome Incognito, Microsoft Edge, and Edge InPrivate (Upload up to 2400 files per browser)",
    guide2Locked: "While uploading files to the system, you can minimize the window to do other tasks while the system continues uploading at normal speed",
    guide3LockedPrefix: "Upload .MP4 files only and duration between",
    guide3LockedSuffix: "seconds",
    guide4Locked: "Videos should not exceed 15 seconds in length (Set camera to Slow at 30FPS, shoot for approximately 3-4 seconds)",
    guide5Locked: "Make sure file names are unique. The system will skip files with duplicate names",
    downloadQrCode: "Download Large QR Code",
    downloadQrCodeLarge: "Download Large QR Code",
    uploadTotal: "upload total",
    fileList: "file list",
    waitForTagging: "wait for tagging",
    tagged: "tagged",
    uploadClosedMessage: "Video upload is closed for this event. If you need to upload additional videos, please contact the team leader or admin.",
    authorizedChecking: "authorized checking...",
    pageNotAuthorized: "this page is not authorized",
    eventNotCorrect: "event is not currect!",
    eventDetailError: "[EventDetail] Error occurred!",
    getCreditError: "[getCredit] Error occurred!",
    authFailed: "Authentication Failed! ",
    authFailedContact: "Authentication Failed! Please contact administrator.",
    taggedError: "[Taged] Error occurred!",
    systemError: "Error occurred. Please contact system administrator or try again.",
  },
  th: {
    usageGuidelines: "คำแนะนำการใช้งานระบบ Upload Video",
    guide1Prefix: "ถ้าต้องการเปิดหลายแท็บ เพื่อเพิ่มความเร็ว",
    guide1Highlight: "ต้องเปิดในเบราว์เซอร์ต่างกัน",
    guide1Tail: "เช่น Google Chrome, Safari(Upload ได้ครั้งละไม่เกิน 2400 ไฟล์), Microsoft Edge, Frifox",
    guide2: "ขณะกำลังอัปโหลดไฟล์เข้าระบบ สามารถย่อหน้าจอ เพื่อทำงานอื่นๆได้ ต่อได้โดยที่ระบบยังคง อัปโหลดให้ด้วยความเร็วปกติ",
    guide3Prefix: "Upload ไฟล์ .mp4 เท่านั้นและ",
    guide3Mid: "มีความยาวอยู่ในช่วงระหว่าง",
    guide3Suffix: "วินาที เท่านั้น",
    guide4: "วิดีโอควรมีขนาดความยาวไม่เกิน 15 วินาที (ตั้งค่ากล้อง Slow เป็น 30FPS, ตอนขณะถ่าย ถ่ายประมาณ 3-5 วินาที)",
    guide5: "ตั้งชื่อไฟล์ไม่ให้ซ้ำกัน ระบบจะ Skip การอัปโหลด ไฟล์ชื่อซ้ำ",
    guide1HighlightLocked: "ต้องเปิดในเบราว์เซอร์ต่างกัน",
    guide1TailLocked: "เช่น Google Chrome, Safari(Upload ได้ครั้งละไม่เกิน 2400 ไฟล์), Microsoft Edge, Frifox",
    guide2Locked: "ขณะกำลังอัปโหลดไฟล์เข้าระบบ สามารถย่อหน้าจอ เพื่อทำงานอื่นๆได้ ต่อได้โดยที่ระบบยังคง อัปโหลดให้ด้วยความเร็วปกติ",
    guide3LockedPrefix: "Upload ไฟล์ .mp4 เท่านั้นและ",
    guide3LockedSuffix: "วินาที เท่านั้น",
    guide4Locked: "วิดีโอควรมีขนาดความยาวไม่เกิน 15 วินาที (ตั้งค่ากล้อง Slow เป็น 30FPS, ตอนขณะถ่าย ถ่ายประมาณ 3-5 วินาที)",
    guide5Locked: "ตั้งชื่อไฟล์ไม่ให้ซ้ำกัน ระบบจะ Skip การอัปโหลด ไฟล์ชื่อซ้ำ",
    downloadQrCode: "ดาวน์โหลด QRCode ขนาดใหญ่",
    downloadQrCodeLarge: "Download Large QR Code",
    uploadTotal: "upload total",
    fileList: "file list",
    waitForTagging: "wait for tagging",
    tagged: "tagged",
    uploadClosedMessage: "กิจกรรมนี้ปิดการอัปโหลดวิดีโอ หากต้องการอัปโหลดวิดีโอเพิ่มเติม กรุณาติดต่อหัวหน้าทีม หรือแอดมิน",
    authorizedChecking: "authorized checking...",
    pageNotAuthorized: "this page is not authorized",
    eventNotCorrect: "event is not currect!",
    eventDetailError: "[EventDetail]พบข้อผิดพลาด!",
    getCreditError: "[getCredit] พบข้อผิดพลาด!",
    authFailed: "การตรวจสอบสิทธิ์ล้มเหลว! ",
    authFailedContact: "การตรวจสอบสิทธิ์ล้มเหลว! กรุณาติดต่อผู้ดูแลระบบ",
    taggedError: "[Taged] พบข้อผิดพลาด!",
    systemError: "พบข้อผิดพลาดกรุณาติดต่อผู้ดูแลระบบ หรือลองใหม่อีกครั้ง",
  },
};

export default {
  components: { language },
  setup() {
    const upload_store_vdo = useUploadStoreVdo();
    return { upload_store_vdo };
  },
  data() {
    return {
      websiteUrl: process.env.VUE_APP_WEBSITE_URL,
      eventDetails: {},
      selectedFiles: [],
      processing: 0,
      taged: 0,
      total: 0,
      loading: true,
      user: {},
      qr_code: process.env.VUE_APP_WEBSITE_URL + "/" + this.$route.params.q,
      is_event_permission: "CHECKING",
      event_stages: 0,
      credit_balance: 0,
      website_url: process.env.VUE_APP_WEBSITE_URL,
      is_image_addjustment: "N",
      min_duration_sec: process.env.VUE_APP_MIN_DURATION_SEC,
      max_duration_sec: process.env.VUE_APP_MAX_DURATION_SEC,
    };
  },
  computed: {
    currentLanguage() {
      return (process.env.VUE_APP_LANGUAGE || "").toLowerCase() === "en"
        ? "en"
        : "th";
    },
    uploadingFiles() {
      return this.upload_store_vdo.selectedFiles.filter(
        (file) => file.status === "uploading"
      );
    },
    uploadingFilesFailed() {
      return this.upload_store_vdo.selectedFiles.filter(
        (file) => file.status === "failed"
      );
    },
  },
  async mounted() {
    try {
      this.user = JSON.parse(localStorage.getItem("user"));
      let _is_event_permission = await this.event_permission();
      if (_is_event_permission === "Y") {
        let eventDetail = await this.getEventDetail(this.$route.params.q);
        await this.getTaged(eventDetail.event_id, this.user.user_id);
        if (
          this.eventDetails.is_hybrid === "Y" &&
          this.eventDetails.is_mhao_hybrid === "N"
        ) {
          await this.getCredit();
        }
      }
    } catch (error) {
      alert(
        this.t("systemError"),
        error
      );
      location.reload();
    }
  },
  methods: {
    t(key) {
      return LANGUAGE_TEXT[this.currentLanguage][key] || LANGUAGE_TEXT.en[key] || key;
    },
    async getCredit(event_id, photographer_id) {
      const data = {
        event_id: event_id,
        photographer_id: photographer_id,
      };
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      };
      const res = await axios.post("/v1/utils/credit-balance", data, {
        headers,
      });
      if (res.data.status === "success") {
        this.credit_balance = res.data.body.credit_balance;
      } else {
        alert(this.t("getCreditError"));
      }
    },
    async clear_upload() {
      document.getElementById("selectBtn").value = null;
      this.upload_store_vdo.clearFiles();
      this.event_stages = 0;
    },
    async event_permission() {
      try {
        let data = {
          event_key: this.$route.params.q,
        };
        const headers = {
          Authorization: "Bearer " + localStorage.getItem("jwt"),
        };
        const response = await axios.post("v1/order/event-permission", data, {
          headers,
        });
        if (response.data.status === "success") {
          this.is_event_permission = response.data.body.event_permission;
          return response.data.body.event_permission;
        } else {
          alert(this.t("authFailed"));
          return "N";
        }
      } catch (error) {
        alert(this.t("authFailedContact"));
        return "N";
      }
    },

    async getEventDetail(event_key) {
      const res = await axios.get("/v1/events/" + event_key);
      if (res.data.status === "success") {
        this.eventDetails = res.data;
        this.eventPackage = res.data.package;
        return res.data;
      } else {
        alert(this.t("eventDetailError"));
        this.$router.push({ path: "/" });
      }
    },
    async getTaged(event_id, photographer_id) {
      const data = {
        event_id: event_id,
        photographer_id: photographer_id,
      };
      const res = await axios.post("/v1/events/taged-video", data);
      if (res.data.status === "success") {
        this.processing = res.data.processing;
        this.taged = res.data.taged;
        this.total = res.data.total;
      } else {
        alert(this.t("taggedError"));
        this.$router.push({ path: "/" });
      }
    },
    cancel() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>
<style scoped lang="scss">
#selectBtn {
  display: none;
}
.progress-bar-wrapper {
  height: 3px;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 2px;
}

.progress-bar-fill {
  height: 100%;
  background-color: #1890ff; /* ant.design style color */
  transition: width 0.1s ease;
}
.small-text {
  font-size: 13px;
  line-height: 1.2;
}
.card-btn-upload {
  text-align: center;
}
.card-file-list {
  text-align: center;
}

.upload-item {
  border: 1px solid rgb(197, 197, 197);
  border-radius: 0.5rem;
  float: left;
  padding: 1px;
  text-align: center;
}

.drop-container:hover {
  background: #979696ad;
}
.upload-item:hover {
  background: #e0e0e0ad;
  cursor: pointer;
  border: 1px dashed rgba(124, 2, 2, 0.616);
}

.buttons {
  display: flex;
  gap: 1rem;

  &.centered {
    justify-content: center;
  }
}

.button {
  cursor: pointer;

  color: white;
  background: #809af0;
  text-decoration: none;

  width: fit-content;
  padding: 0.5rem 1rem;
  border-radius: 2px;

  &:hover {
    background: #3f6cff;
  }

  &.disabled {
    cursor: default;
    background: lightgray;
    pointer-events: none;
  }
}

.button-danger {
  background: #f08080;

  &:hover {
    background: #f65959;
  }
}

.button-upload {
  background: #00d591;

  &:hover {
    background: #02b97f;
  }
}

.failed {
  color: red;
  font-size: x-small;
}

.success {
  color: green;
}

.uploading {
  color: #000000;
  font-size: x-small;
}

.failed-border {
  border-color: red;
}

textarea {
  width: 100%;
  background-color: #ffffffea;
  border-radius: 0.7rem;
}
.textwrapper {
  border: 1px solid #999999;
  margin: 5px 0;
  padding: 3px;
}
</style>